import { graphHooks } from '@tunasong/graph-lib/react'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import AvatarList, { type AvatarListProps } from './avatar-list.js'

export interface AccessAvatarListProps extends Omit<AvatarListProps, 'userIds'> {
  entity: Persisted<Entity>
}

/**
 * Display a list of user avatars that have access to the entity.
 */
export const AccessAvatarList: FC<AccessAvatarListProps> = props => {
  const { entity, ...restProps } = props
  const { members } = graphHooks.useMembers(entity)
  return <AvatarList userIds={members.map(m => m.id)} {...restProps} />
}

export default AccessAvatarList
